import { useState, useEffect } from "react";
import AppHeader from "./../../../components/common/appHeader/AppHeader";
import PageTitle from "./../../../components/common/pageTitle/PageTitle";
import { useNavigate } from "react-router-dom";
import { useRecommendHall } from "./../../../utils/hooks/useRecommendHall";
import { setMealPrice } from "@src/@slice/recommendHallSlice";
import { numberToKorean } from "./../../../utils/index";
import Blank from "../../../components/common/blank/Blank";
import LinkWegazine from "../../../components/common/linkWegazine/LinkWegazine";
import NotificationArccodion from "@src/components/booking/realtimeBooking/notification/NotificationArccodion";
import CustomHeader from "@src/components/common/appHeader/CustomHeader";
import { closeWebview } from "@src/utils/route";

// const priceItems = ["~50000", "50000~60000", "60000~70000", "70000~90000", "90000~"];
const priceItems = ["40000~60000", "60000~70000", "70000~90000", "90000~"];
const Cost = () => {
  const navigate = useNavigate();
  const [validate, setValidate] = useState(false);
  const { hallData, dispatch } = useRecommendHall();
  useEffect(() => {
    const meal = hallData.meal;
    setValidate(meal.minPrice !== null || meal.maxPrice !== null);
  }, [hallData.meal]);
  // useEffect(() => {
  //   if (
  //     hallData.hallStyleTypes.length === 0 ||
  //     hallData.weddingType === "" ||
  //     hallData.weddingRegions.length === 0 ||
  //     (hallData.expectedPerson.min === null && hallData.expectedPerson.max === null) ||
  //     hallData.meal.types.length === 0
  //   ) {
  //     navigate("/recommend/hall/start", { replace: true });
  //   }
  // }, []);
  const goNext = () => {
    navigate("/recommend/hall/hope-date");
  };
  return (
    <div>
      <CustomHeader goBack={() => navigate("/recommend/hall/meal-type")} close={closeWebview} />
      {/* <AppHeader type="stack" actionItems={[{ name: "close" }]} /> */}
      <div className="recommend-hall-cost">
        <div>
          <PageTitle title={`1인당 식사 비용을 선택해 주세요.`} type="" />
          <div className="common-wrap">
            <div style={{ height: 20 }} />
            <ul className="selectable-list-wrap items-2 font-size-up">
              {priceItems.map((item) => {
                const splitVal = item.split("~");
                const val0 = splitVal[0];
                const val1 = splitVal[1];
                const min = hallData.meal.minPrice ? hallData.meal.minPrice : "";
                const max = hallData.meal.maxPrice ? hallData.meal.maxPrice : "";
                return (
                  <li key={`cost-item-${item}`}>
                    <div
                      className={`${val0}~${val1}` === `${min}~${max}` ? "selected" : ""}
                      onClick={() =>
                        dispatch(
                          setMealPrice({
                            min: val0 ? +val0 : null,
                            max: val1 ? +val1 : null,
                          }),
                        )
                      }
                    >
                      {val0 && val1 && (
                        <>
                          {val0 ? `${numberToKorean(val0)}` : ""} ~{" "}
                          {val1 ? `${numberToKorean(val1)}` : ""}
                        </>
                      )}
                      {val0 === "" && <>{numberToKorean(val1)} 미만</>}
                      {val1 === "" && <>{numberToKorean(val0)} 이상</>}
                    </div>
                  </li>
                );
              })}
            </ul>
            <NotificationArccodion
              className="recommend-hall-noti"
              isOpen={true}
              title="식사 비용 예산 설정 시 참고해 주세요."
              useArccodion={false}
            >
              <div>
                <p>
                  보통 같은 웨딩홀이라도 예식 날짜와 시간대에 따라 식사 비용이 조율됩니다. 아래의
                  예상 견적 산출 방법을 참고하여 선택해 보세요.
                </p>
                <ul>
                  <li>
                    웨딩홀 총 견적 = 부대 비용(대관료, 플라워 등) + 식사비용(1인 식사비용 * 예상
                    보증 인원)
                  </li>
                </ul>
                <p>
                  1인 식사 비용과 예상 인원수를 고려해 예산을 설정할 수 있습니다. (전문 사회 등 추가
                  옵션은 웨딩홀마다 상이합니다.)
                </p>
              </div>
            </NotificationArccodion>
          </div>
        </div>
        <div>
          <Blank height={20} />
          <div className="btn-wrap gradient">
            <button
              onClick={goNext}
              className={`btn btn-giant btn-red500 btn-full ${!validate ? "btn-disabled" : ""}`}
              disabled={!validate}
            >
              다음
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cost;
